import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleInsuranceDto } from '../../dtos/create-vehicle-insurance.dto';
import { UpdateVehicleInsuranceDto } from '../../dtos/update-vehicle-insurance.dto';
import { createVehicleInsuranceSchema } from '../schemas/create-vehicle-insurance.schema';
import { updateVehicleInsuranceSchema } from '../schemas/update-vehicle-insurance.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleInsuranceDto | UpdateVehicleInsuranceDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateVehicleInsuranceSchema if 'id' is present
		validationResult = updateVehicleInsuranceSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createVehicleInsuranceSchema if 'id' is not present
		validationResult = createVehicleInsuranceSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
